import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-flush mb-10" }
const _hoisted_2 = { class: "card-header pt-9 d-flex justify-content-between" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "symbol symbol-50px me-5"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "symbol symbol-50px me-5"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/logos/HackingClub_LogoVariados-03.png",
  class: "",
  alt: ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "flex-grow-1"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = { class: "text-gray-500" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "text-gray-400 fw-light"
}
const _hoisted_14 = {
  key: 0,
  title: "Elite Member",
  class: "bi bi-award fs-3",
  style: {"color":"white"}
}
const _hoisted_15 = ["title", "src"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_17 = {
  key: 1,
  class: "mx-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill text-warning" }),
  /*#__PURE__*/_createTextVNode(" Support")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "badge badge-light-danger"
}
const _hoisted_21 = {
  key: 3,
  class: "badge badge-light-info"
}
const _hoisted_22 = {
  key: 4,
  class: "badge badge-light-success"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "badge badge-light-primary" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-right" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "path1" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "path2" }, null, -1)
const _hoisted_29 = { class: "badge badge-light-primary" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-right" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "path1" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "path2" }, null, -1)
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 3,
  class: "flex-grow-1"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("a", { class: "text-gray-800 text-hover-primary fs-4 fw-bold" }, "Hacking Club", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_38 = {
  key: 1,
  class: "badge badge-light-info"
}
const _hoisted_39 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_40 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_42 = {
  key: 4,
  class: "badge badge-light-success"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_44 = ["href"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-primary" }, [
  /*#__PURE__*/_createTextVNode("Go to machine "),
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-right" }),
  /*#__PURE__*/_createElementVNode("i", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("i", { class: "path2" })
], -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["href"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-primary" }, [
  /*#__PURE__*/_createTextVNode("Go to machine "),
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-right" }),
  /*#__PURE__*/_createElementVNode("i", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("i", { class: "path2" })
], -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "card-toolbar" }
const _hoisted_52 = { class: "m-0" }
const _hoisted_53 = { class: "d-flex align-content-end" }
const _hoisted_54 = { class: "d-flex flex-column" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-message-minus fs-3 text-danger" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = {
  class: "fs-6 fw-normal text-gray-800",
  style: {"white-space":"pre-line"}
}
const _hoisted_60 = { class: "card-footer pt-0" }
const _hoisted_61 = { class: "mb-6" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-solid" }, null, -1)
const _hoisted_63 = { class: "nav py-3 d-flex justify-content-between w-full" }
const _hoisted_64 = { class: "nav-item" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-heart fs-3 text-danger" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-rocket fs-3 text-warning" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-like fs-3 text-primary" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-ghost fs-3 text-success" }, null, -1)
const _hoisted_69 = { class: "nav-item" }
const _hoisted_70 = { class: "svg-icon svg-icon-3 text-success" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-solid mb-1" }, null, -1)
const _hoisted_72 = { class: "symbol symbol-45px me-5" }
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_75 = { class: "d-flex align-items-center flex-wrap mb-0" }
const _hoisted_76 = { class: "text-gray-500" }
const _hoisted_77 = ["title"]
const _hoisted_78 = { class: "mt-1" }
const _hoisted_79 = {
  key: 0,
  class: "text-gray-400 fw-light"
}
const _hoisted_80 = ["title", "src"]
const _hoisted_81 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_82 = {
  key: 1,
  class: "mx-2"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill text-warning" }),
  /*#__PURE__*/_createTextVNode(" Support")
], -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  class: "fs-6 fw-normal text-gray-700 mt-5",
  style: {"white-space":"pre-line","padding-right":"110px"}
}
const _hoisted_86 = { class: "nav py-3 d-flex justify-content-between w-full" }
const _hoisted_87 = { class: "nav-item" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-heart fs-3 text-danger" }, null, -1)
const _hoisted_90 = ["onClick"]
const _hoisted_91 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-rocket fs-3 text-warning" }, null, -1)
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-like fs-3 text-primary" }, null, -1)
const _hoisted_94 = ["onClick"]
const _hoisted_95 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-ghost fs-3 text-success" }, null, -1)
const _hoisted_96 = {
  class: "d-flex flex-column",
  style: {"margin-top":"-80px"}
}
const _hoisted_97 = ["onClick"]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-message-minus fs-3 text-danger" }, null, -1)
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_100 = [
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-message-add fs-3 text-success" }, null, -1)
const _hoisted_103 = { class: "d-flex align-items-center" }
const _hoisted_104 = { class: "symbol symbol-35px me-3" }
const _hoisted_105 = ["src"]
const _hoisted_106 = { class: "position-relative w-100" }
const _hoisted_107 = ["rows", "placeholder"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-send fs-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = {
  key: 1,
  class: "position-absolute top-50 end-0 translate-middle-y mt-5 me-5"
}
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_112 = [
  _hoisted_111
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.feed?.type != 'release')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.feed?.user?.avatar,
                class: "",
                alt: ""
              }, null, 8, _hoisted_5)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
        (_ctx.feed?.type !== 'release')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: { name: 'profile-user', params: { id: _ctx.feed?.user?.id } },
                class: "text-gray-800 text-hover-primary fs-4 fw-bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.feed?.user?.nick || 'No nick'), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _hoisted_10,
              _createElementVNode("small", _hoisted_11, "@" + _toDisplayString(_ctx.feed?.user?.nick || 'No nick'), 1),
              _hoisted_12,
              (_ctx.feed?.user?.user_patent)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    (_ctx.feed?.user?.is_elite)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                      : _createCommentVNode("", true),
                    _createElementVNode("img", {
                      title: _ctx.feed?.user?.user_patent?.name,
                      src: '/media/logos/badges/' + _ctx.feed?.user?.user_patent?.icon,
                      class: "h-20px align-self-center px-1",
                      alt: ""
                    }, null, 8, _hoisted_15),
                    _createTextVNode(" " + _toDisplayString(_ctx.feed?.user?.user_patent?.name), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_16,
              (_ctx.feed?.user?.is_admin)
                ? (_openBlock(), _createElementBlock("a", _hoisted_17, _hoisted_19))
                : _createCommentVNode("", true),
              (_ctx.feed?.type == 'first_blood')
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "First Blood 🩸"))
                : _createCommentVNode("", true),
              (_ctx.feed?.type == 'own_flag')
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Own Flag"))
                : _createCommentVNode("", true),
              (_ctx.feed?.type == 'own_machine')
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Own Machine"))
                : _createCommentVNode("", true),
              _hoisted_23,
              (_ctx.feed?.subject_type == 'App\\Models\\Machine')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 5,
                    href: '/laboratory/competition-machines/' + _ctx.feed?.subject_id
                  }, [
                    _createElementVNode("span", _hoisted_25, [
                      _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.hacktivity.go_to_machine`)), 1),
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28
                    ])
                  ], 8, _hoisted_24))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 6,
                    to: { name: 'training-module-show-lesson', params: { id: _ctx.feed?.module_id, lesson_id: _ctx.feed?.subject_id } }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.hacktivity.go_to_lesson`)), 1),
                        _hoisted_30,
                        _hoisted_31,
                        _hoisted_32
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"])),
              _createElementVNode("span", {
                class: "text-gray-400 fw-semibold d-block",
                title: _ctx.feed?.created_at
              }, _toDisplayString(_ctx.moment(_ctx.feed?.created_at).fromNow()), 9, _hoisted_33)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _hoisted_36,
              (_ctx.feed.subject?.dificulty == 'easy')
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Easy"))
                : _createCommentVNode("", true),
              (_ctx.feed.subject?.dificulty == 'medium')
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Medium"))
                : _createCommentVNode("", true),
              (_ctx.feed.subject?.dificulty == 'hard')
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Hard"))
                : _createCommentVNode("", true),
              (_ctx.feed.subject?.dificulty == 'insane')
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Insane"))
                : _createCommentVNode("", true),
              _hoisted_41,
              (_ctx.feed.subject?.is_freemium)
                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Free"))
                : _createCommentVNode("", true),
              _hoisted_43,
              (_ctx.feed?.subject?.type == 'default')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 5,
                    href: '/laboratory/competition-machines/' + _ctx.feed?.subject?.id
                  }, _hoisted_46, 8, _hoisted_44))
                : (_openBlock(), _createElementBlock("a", {
                    key: 6,
                    href: '/training/training-machines/' + _ctx.feed?.subject?.id
                  }, _hoisted_49, 8, _hoisted_47)),
              _createElementVNode("span", {
                class: "text-gray-400 fw-semibold d-block",
                title: _ctx.feed?.created_at
              }, _toDisplayString(_ctx.moment(_ctx.feed?.created_at).fromNow()), 9, _hoisted_50)
            ]))
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              (_ctx.currentUser?.is_admin && _ctx.isFixedFalseFeed)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFixedHacktivity(_ctx.feed?.id))),
                    class: _normalizeClass(["btn btn-sm px-4 py-2 me-2", _ctx.feed?.is_fixed ? 'btn-active-light-danger' : 'btn-active-light-success'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["bi-pin-angle-fill fs-3", _ctx.feed?.is_fixed ? 'text-danger' : 'text-success'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(_ctx.feed?.is_fixed ? 'Unfixed' : 'Fixed'), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.feed?.user?.id == _ctx.currentUser?.id)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteHacktivityUserAuth(_ctx.feed?.id))),
                    class: "btn btn-sm btn-active-light-danger px-4 py-2 me-2"
                  }, _hoisted_57))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.feed?.headline), 1)
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _hoisted_62,
        _createElementVNode("ul", _hoisted_63, [
          _createElementVNode("li", _hoisted_64, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.react('hacktivity', 'love', _ctx.feed?.id))),
              class: "btn btn-sm btn-active-light-danger px-4 py-2 me-2"
            }, [
              _hoisted_65,
              _createTextVNode(" " + _toDisplayString(_ctx.feed?.reaction?.love), 1)
            ]),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.react('hacktivity', 'fire', _ctx.feed?.id))),
              class: "btn btn-sm btn-active-light-warning px-4 py-2 me-2"
            }, [
              _hoisted_66,
              _createTextVNode(" " + _toDisplayString(_ctx.feed?.reaction?.fire), 1)
            ]),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.react('hacktivity', 'like', _ctx.feed?.id))),
              class: "btn btn-sm btn-active-light-primary px-4 py-2 me-2"
            }, [
              _hoisted_67,
              _createTextVNode(" " + _toDisplayString(_ctx.feed?.reaction?.like), 1)
            ]),
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.react('hacktivity', 'eye', _ctx.feed?.id))),
              class: "btn btn-sm btn-active-light-success px-4 py-2 me-2"
            }, [
              _hoisted_68,
              _createTextVNode(" " + _toDisplayString(_ctx.feed?.reaction?.eye), 1)
            ])
          ]),
          _createElementVNode("li", _hoisted_69, [
            _createElementVNode("a", {
              class: "btn btn-sm btn-active-light-success px-4 py-2",
              "data-bs-toggle": "collapse",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openComment()))
            }, [
              _createElementVNode("span", _hoisted_70, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com012.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.feed?.comments?.length), 1)
            ])
          ])
        ]),
        _hoisted_71,
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.comments_view ? 'collapse show' : 'collapse')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feed?.comments, (comment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: comment.id,
              class: "d-flex pt-6 pb-3"
            }, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("img", {
                  src: comment?.user?.avatar,
                  alt: ""
                }, null, 8, _hoisted_73)
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_component_router_link, {
                    to: { name: 'profile-user', params: { id: comment?.user?.id } },
                    class: "text-gray-800 text-hover-primary fw-bold me-6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(comment?.user?.nick || 'No nick') + " ", 1),
                      _createElementVNode("small", _hoisted_76, "@" + _toDisplayString(comment?.user?.nick || 'No nick'), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("span", {
                    class: "text-gray-400 fw-semibold fs-7 me-5",
                    title: comment?.created_at
                  }, _toDisplayString(_ctx.moment(comment?.created_at).fromNow()), 9, _hoisted_77)
                ]),
                _createElementVNode("div", _hoisted_78, [
                  (comment?.user?.user_patent)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                        _createElementVNode("img", {
                          title: comment?.user?.user_patent?.name,
                          src: '/media/logos/badges/' + comment?.user?.user_patent?.icon,
                          class: "h-20px align-self-center",
                          alt: ""
                        }, null, 8, _hoisted_80),
                        _createTextVNode("  " + _toDisplayString(comment?.user?.user_patent?.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_81,
                  (comment?.user?.is_admin)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_82, _hoisted_84))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_85, _toDisplayString(comment?.message), 1),
                _createElementVNode("ul", _hoisted_86, [
                  _createElementVNode("li", _hoisted_87, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.react('comment', 'love', comment?.id)),
                      class: "btn btn-sm btn-active-light-danger px-4 py-2 me-2"
                    }, [
                      _hoisted_89,
                      _createTextVNode(" " + _toDisplayString(comment?.reactions?.love), 1)
                    ], 8, _hoisted_88),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.react('comment', 'fire', comment?.id)),
                      class: "btn btn-sm btn-active-light-warning px-4 py-2 me-2"
                    }, [
                      _hoisted_91,
                      _createTextVNode(" " + _toDisplayString(comment?.reactions?.fire), 1)
                    ], 8, _hoisted_90),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.react('comment', 'like', comment?.id)),
                      class: "btn btn-sm btn-active-light-primary px-4 py-2 me-2"
                    }, [
                      _hoisted_93,
                      _createTextVNode(" " + _toDisplayString(comment?.reactions?.like), 1)
                    ], 8, _hoisted_92),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.react('comment', 'eye', comment?.id)),
                      class: "btn btn-sm btn-active-light-success px-4 py-2 me-2"
                    }, [
                      _hoisted_95,
                      _createTextVNode(" " + _toDisplayString(comment?.reactions?.eye), 1)
                    ], 8, _hoisted_94)
                  ]),
                  _createElementVNode("li", _hoisted_96, [
                    ((comment?.user.id == _ctx.currentUser?.id) || _ctx.currentUser?.is_admin)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.deleteComment(comment)),
                          class: "btn btn-sm btn-active-light-danger px-4 py-2 me-2"
                        }, _hoisted_100, 8, _hoisted_97))
                      : _createCommentVNode("", true),
                    ((comment?.user.id != _ctx.currentUser?.id) || _ctx.currentUser?.is_admin)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.replyComment(comment)),
                          class: "btn btn-sm btn-active-light-success px-4 py-2 me-2"
                        }, [
                          _hoisted_102,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.reply`)), 1)
                        ], 8, _hoisted_101))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          }), 128))
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("img", {
            src: _ctx.currentUser?.avatar,
            alt: ""
          }, null, 8, _hoisted_105)
        ]),
        _createElementVNode("div", _hoisted_106, [
          _withDirectives(_createElementVNode("textarea", {
            ref: "CurrentComment",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.current_comment) = $event)),
            type: "text",
            class: "form-control form-control-solid border ps-5",
            rows: _ctx.current_comment_focus ? 2 : 1,
            onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.current_comment_focus = true)),
            onFocusout: _cache[9] || (_cache[9] = ($event: any) => (_ctx.current_comment ? _ctx.current_comment_focus = true : _ctx.current_comment_focus = false)),
            name: "search",
            "data-kt-autosize": "true",
            placeholder: _ctx.$t(`${_ctx.currentLanguage}.hacktivity.write_your_comment`),
            "data-kt-initialized": "1",
            style: {"overflow":"hidden","overflow-wrap":"break-word","resize":"none","text-align":"start"}
          }, null, 40, _hoisted_107), [
            [_vModelText, _ctx.current_comment]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.current_comment_focus ? 'position-absolute top-0 end-0 translate-middle-x mt-5' : 'position-absolute top-0 end-0 translate-middle-x mt-1')
          }, [
            (!_ctx.loading_comment)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.comment())),
                  class: "btn btn-icon btn-sm btn-color-gray-500 btn-active-color-primary w-25px p-0"
                }, _hoisted_109))
              : _createCommentVNode("", true),
            (_ctx.loading_comment)
              ? (_openBlock(), _createElementBlock("span", _hoisted_110, _hoisted_112))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ]))
}